import { parseFlatFeeInput } from '../../../../components/FeeShape/flatFeeInput'

// The card split (WS #2228900, under #2219705): PACK's one-time flat fee over up to 6 cards. These
// rules only decide what the screen lets the rep save; the server checks the same again on the save
// (vlg-server services/payments/cardSplit.js) and refuses with the reason.
export const MAX_CARDS = 6
export const CLIENT = 'client'
export const OTHER = 'other'

export const emptyRow = () => ({ billingAccount: '', amountText: '', holder: CLIENT, holderEmail: '', holderPhone: '' })

const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? '').trim())
const isPhone = (value) => /^\d{10,15}$/.test(String(value ?? '').replace(/\D/g, ''))

// Amounts follow the fee field's rule: whole dollars above $0, "$3,000" accepted.
const amountOf = (row) => parseFlatFeeInput(row.amountText).amount

export const resizeRows = (rows, count) => {
  const size = Math.min(MAX_CARDS, Math.max(1, Number(count) || 1))
  return Array.from({ length: size }, (_, i) => rows[i] || emptyRow())
}

export const splitTotal = (rows) => rows.reduce((sum, row) => sum + (amountOf(row) || 0), 0)

export const rowProblem = (row) => {
  if (!row.billingAccount) return 'Pick a card'
  if (!amountOf(row)) return 'Enter a whole-dollar amount above $0'
  if (row.holder === OTHER && !isEmail(row.holderEmail) && !isPhone(row.holderPhone)) {
    return 'Add the cardholder\'s email or mobile number'
  }
  return null
}

export const duplicateCard = (rows) => {
  const picked = rows.map((row) => row.billingAccount).filter(Boolean)
  return new Set(picked).size !== picked.length
}

export const canSaveSplit = ({ rows, flatFee }) =>
  Number.isInteger(flatFee) && flatFee > 0
  && rows.every((row) => !rowProblem(row))
  && !duplicateCard(rows)
  && splitTotal(rows) === flatFee

// What PUT /lead-details stores. A client's own card carries no holder contact.
export const toCardSplit = (rows) => rows.map((row) => ({
  billingAccount: row.billingAccount,
  amount: amountOf(row),
  holder: row.holder,
  ...(row.holder === OTHER && isEmail(row.holderEmail) ? { holderEmail: row.holderEmail.trim() } : {}),
  ...(row.holder === OTHER && isPhone(row.holderPhone) ? { holderPhone: row.holderPhone.trim() } : {}),
}))

export const rowsFromSplit = (cardSplit) => (Array.isArray(cardSplit) && cardSplit.length
  ? cardSplit.map((row) => ({
    billingAccount: row.billingAccount || '',
    amountText: row.amount == null ? '' : String(row.amount),
    holder: row.holder === OTHER ? OTHER : CLIENT,
    holderEmail: row.holderEmail || '',
    holderPhone: row.holderPhone || '',
  }))
  : [emptyRow()])
